import { KAPLAYCtx } from "kaplay";
import { useCallback, useRef } from "react";
import { VictoryState } from "../game";
import { GameControls } from "../game-controls";

export function useGameCleanup() {
  const kaplayInstance = useRef<KAPLAYCtx | null>(null);
  const resizeObserverRef = useRef<ResizeObserver | null>(null);
  const gameInitialized = useRef(false);

  const cleanupGame = useCallback(
    (
      setGameControls: (controls: GameControls | null) => void,
      setScore: (score: number | undefined) => void,
      setShowCredits: (show: boolean) => void,
      setVictoryState: (state: VictoryState) => void,
      setPreprocessedPlayerSprite: (sprite: any) => void,
      setPreprocessedNpcSprite: (sprite: any) => void,
    ) => {
      if (kaplayInstance.current) {
        kaplayInstance.current.quit();
        kaplayInstance.current = null;
      }
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
        resizeObserverRef.current = null;
      }
      gameInitialized.current = false;
      setGameControls(null);
      setScore(undefined);
      setShowCredits(false);
      setVictoryState(VictoryState.IN_PROGRESS);
      setPreprocessedPlayerSprite(null);
      setPreprocessedNpcSprite(null);
    },
    [],
  );

  return { kaplayInstance, resizeObserverRef, gameInitialized, cleanupGame };
}
